// GeolocationService.js
import { ClientURI, TestMode, SaisieMode } from "../shared";

export const getLocationByIP = async () => {
  try {
    // 1. Essayer d'abord votre backend
    const backendResponse = await fetch(`${ClientURI}/geolocation`);
    if (backendResponse.ok) {
      const backendData = await backendResponse.json();
      console.log("Backend geolocation success:", backendData);
      
      return {
        success: true,
        source: 'backend',
        latitude: backendData.latitude,
        longitude: backendData.longitude,
        city: backendData.city,
        country: backendData.country,
        country_code: backendData.country_code?.toLowerCase(),
      };
    }
  } catch (backendError) {
    console.warn("Backend geolocation failed, trying fallback:", backendError);
  }

  try {
    // 2. Fallback vers ipwhois.app
    const fallbackResponse = await fetch('https://ipwhois.app/json/', {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
      }
    });
    
    if (!fallbackResponse.ok) {
      throw new Error(`HTTP error! status: ${fallbackResponse.status}`);
    }
    
    const fallbackData = await fallbackResponse.json();
    console.log("Fallback geolocation success:", fallbackData);
    
    if (fallbackData.success) {
      return {
        success: true,
        source: 'ipwhois',
        latitude: fallbackData.latitude,
        longitude: fallbackData.longitude,
        city: fallbackData.city,
        country: fallbackData.country,
        country_code: fallbackData.country_code?.toLowerCase(),
      };
    }
  } catch (fallbackError) {
    console.error("Fallback geolocation failed:", fallbackError);
  }

  try {
    // 3. Dernier fallback vers ipapi.co
    const lastResortResponse = await fetch('https://ipapi.co/json/');
    const lastResortData = await lastResortResponse.json();
    console.log("Last resort geolocation:", lastResortData);
    
    return {
      success: true,
      source: 'ipapi',
      latitude: lastResortData.latitude,
      longitude: lastResortData.longitude,
      city: lastResortData.city,
      country: lastResortData.country_name,
      country_code: lastResortData.country_code?.toLowerCase(),
    };
  } catch (lastError) {
    console.error("All geolocation services failed:", lastError);
    return {
      success: false,
      error: "Unable to detect location"
    };
  }
};
// Permet de donner le code pays par GPS (ou fallback IP)
export const getCountryByGPSOrIP = async () => {
  // Ne pas détecter si TestMode ou SaisieMode
  if (TestMode || SaisieMode) {
    return {
      country_code: null,
      source: "mode_disabled",
      latitude: null,
      longitude: null
    };
  }

  try {
    // 1. Tenter d'obtenir les coordonnées GPS
    const position = await getGPSCoordinates();
    const { latitude, longitude } = position.coords;

    // 2. Faire un reverse geocoding pour obtenir le country_code
    const geoRes = await fetch(
      `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`
    );
    const geoData = await geoRes.json();
    if (geoData.countryCode) {
      return {
        country_code: geoData.countryCode.toLowerCase(),
        latitude,
        longitude,
        source: 'gps'
      };
    }
  } catch (err) {
    console.warn('GPS/localisation échouée, fallback IP. Détail:', err);
  }

  // 3. Fallback par IP si GPS pas possible
  const ipRes = await getLocationByIP();
  return {
    country_code: ipRes?.country_code,
    latitude: ipRes?.latitude,
    longitude: ipRes?.longitude,
    source: ipRes?.source || 'ip'
  };
};

export const getGPSCoordinates = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("Geolocation not supported"));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      resolve,
      (err) => {
        reject(new Error(
          err.code === err.PERMISSION_DENIED 
            ? "Permission denied. Please enable GPS." 
            : "Unable to get GPS position"
        ));
      },
      {
        enableHighAccuracy: true,
        timeout: 15000,
        maximumAge: 0
      }
    );
  });
};

export const detectCountryByIP = async () => {
  try {
    console.log('🌍 Détection du pays par IP...');
    const response = await fetch('https://ipwhois.app/json/');
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    
    if (data.success) {
      const countryCode = data.country_code?.toLowerCase();
      console.log(`🎯 Pays détecté: ${countryCode?.toUpperCase() || 'Unknown'}`);
      
      return {
        success: true,
        country_code: countryCode,
        country_name: data.country,
        city: data.city,
        region: data.region,
        latitude: data.latitude,
        longitude: data.longitude,
        full_data: data
      };
    } else {
      throw new Error('IP detection failed');
    }
  } catch (error) {
    console.error('❌ Erreur lors de la détection IP:', error);
    return {
      success: false,
      error: error.message
    };
  }
};